import { RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS } from '@fabric-app/ui/theme/resourcePreviewConstants';
import { create } from 'zustand';
import { persist } from '../../../node_modules/zustand/esm/middleware.js';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

const createDefaultState = (contextName, defaultValues) => (set) => ({
  zoomLevel: 0.9,
  hideTitle: false,
  hideTags: false,
  hideComment: false,
  ...defaultValues,
  contextName,
  toggleTitle: () => set((state) => ({
    hideTitle: !state.hideTitle
  })),
  togglePinnedComment: () => set((state) => ({
    hideComment: !state.hideComment
  })),
  toggleTags: () => set((state) => ({
    hideTags: !state.hideTags
  }))
});
const useGlobalStore = create()(delayedTrackZustand(persist(createDefaultState("global", {}), {
  name: `resource-ui-store-global`,
  version: 0.1
})));
const useSearchStore = create()(delayedTrackZustand(persist(createDefaultState("search", {}), {
  name: `resource-ui-store-search`,
  version: 0.1
})));
const useAssistantStore = create()(delayedTrackZustand(persist(createDefaultState("assistant", {
  zoomLevel: 1,
  hideComment: true,
  hideTags: true,
  hideTitle: true
}), {
  name: `resource-ui-store-assistant`,
  version: 0.1
})));
const useHomeRecentStore = create()(delayedTrackZustand(persist(createDefaultState("homeRecent", {
  zoomLevel: 1,
  hideComment: false,
  hideTags: false,
  hideTitle: false,
  gridPreviewDimensions: RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS
}), {
  name: `resource-ui-store-home-recent`,
  version: 0.3
})));
const store = {
  assistant: useAssistantStore,
  global: useGlobalStore,
  search: useSearchStore,
  homeRecent: useHomeRecentStore
};
const useResourcesUiStore = (uiContext = "global") => {
  const use = store[uiContext];
  return use();
};

export { useResourcesUiStore };
//# sourceMappingURL=useResourcesUiStore.js.map
